import { ROUTES } from './routes';
import { Role } from '@core/auth/types/auth.types';

export interface NavItem {
  label: string;
  href: string;
  icon?: string;
  highlight?: boolean;
}

export interface UserMenuItem {
  label: string;
  href?: string;
  action?: 'logout';
  icon?: string;
  /** Optional role restriction - if set, item only shows for these roles */
  roles?: Role[];
}

export interface SocialLink {
  platform: 'instagram' | 'facebook';
  url: string;
  ariaLabel: string;
}

export interface ContactInfo {
  email: string;
  phone: string;
  whatsappNumber: string;
}

export const HEADER_NAV_ITEMS: NavItem[] = [
  { label: 'Catálogo', href: ROUTES.CATALOG },
  { label: 'Temáticas', href: ROUTES.THEMES, highlight: true },
];

export const FOOTER_NAV_ITEMS: NavItem[] = [
  { label: 'Catálogo', href: ROUTES.CATALOG },
  { label: 'Temáticas', href: ROUTES.THEMES },
];

export const CUSTOMER_SERVICE_ITEMS: NavItem[] = [
  { label: 'Información de Envío', href: ROUTES.SHIPPING },
  { label: 'Preguntas Frecuentes', href: ROUTES.FAQ },
  { label: 'Términos y Privacidad', href: ROUTES.PRIVACY },
];

export const USER_MENU_ITEMS: UserMenuItem[] = [
  {
    label: 'Dashboard',
    href: '/dashboard', // Placeholder - dynamically replaced by role
    icon: 'LayoutDashboard',
    roles: [Role.VENDOR, Role.ADMIN],
  },
  { label: 'Mi Perfil', href: ROUTES.PROFILE, icon: 'User' },
  { label: 'Mis Pedidos', href: ROUTES.ORDERS, icon: 'Package' },
  { label: 'Cerrar Sesión', action: 'logout', icon: 'LogOut' },
];

export const SOCIAL_LINKS: SocialLink[] = [
  {
    platform: 'instagram',
    url: 'https://www.instagram.com/reconocete__/',
    ariaLabel: 'Síguenos en Instagram',
  },
  {
    platform: 'facebook',
    url: 'https://www.facebook.com/Reconocetee',
    ariaLabel: 'Síguenos en Facebook',
  },
];

export const CONTACT_INFO: ContactInfo = {
  email: 'servicioalcliente@reconocete.co',
  phone: '+57 323 66 83 644',
  whatsappNumber: '573236683644',
};
